module.exports = __webpack_public_path__ + "media/images/front/review_star_03-537b78dc4b6da794b3d9ebc2b5b58294.png";